import React, { Component } from "react"
import { getMenusByDate } from "../utils/getMenus"
import MenuCard from "../components/menuCard"

class MenuList extends Component {
  render() {
    const {
      allMenus,
      currentDate,
      selectedFoodType,
      selectedRestaurant,
    } = this.props

    const todaysMenus = getMenusByDate(
      currentDate,
      allMenus,
      selectedFoodType,
      selectedRestaurant
    )
    const menuList =
      todaysMenus.length > 0
        ? todaysMenus.map(menu => <MenuCard key={menu.id} details={menu} />)
        : null
    return (
      <section className="section section--small">
        {menuList !== null ? (
          <div className="grid-x grid-margin-x align-stretch">{menuList}</div>
        ) : (
          <h2 className="h1 mb-0">Aucun restaurant pour votre recherche</h2>
        )}
      </section>
    )
  }
}

export default MenuList
